module.exports = __webpack_public_path__ + "img/small-5.03af1aee.jpg";